import Text from 'components/Text/Text';
import React, { useContext, useMemo } from 'react';
import { IFirmwareByIDsRestaurantsForFirmware, TFirmwareType } from 'types';
import { firmwareTypes } from 'appConstants';
import {
	IFirmwareAssignmentContext,
	FirmwareAssignmentContext,
} from '../../../../../firmwareAssignmentState/firmwareAssignmentContext';
import breadcrumbs from 'images/breadcrumbs.svg';
import classNames from 'classnames';
import style from './Firmware.module.scss';

interface IFirmware {
	data: IFirmwareByIDsRestaurantsForFirmware[];
	restaurantID: string;
}

const Firmware: React.FC<IFirmware> = ({ data, restaurantID }) => {
	const { deleteFirmwareFromRestaurant } = useContext<IFirmwareAssignmentContext>(FirmwareAssignmentContext);

	const getFirmwareTypeName = (firmwareType: TFirmwareType) =>
		firmwareTypes.find((el) => el.firmwareTypeID === firmwareType)?.firmwareTypeName || null;
	const firmwareTypeName = useMemo(() => getFirmwareTypeName, []);

	return (
		<div data-test="Firmware">
			{data.map((el) => {
				const containerClasses = classNames(style.container, { [style.addedItem]: !el.restaurantAddress });

				return (
					<div className={containerClasses} key={el.firmwareId + 'firmwareTab'}>
						<Text className={style.name} translationKey={el.firmwareName} withTooltip={true} />
						<Text className={style.address} translationKey={el.restaurantAddress} withTooltip={true} />
						<Text
							className={style.type}
							translationKey={firmwareTypeName(el.firmwareType)}
							withTooltip={true}
						/>
						<svg
							className={style.closeIcon}
							onClick={() => deleteFirmwareFromRestaurant(restaurantID, el.firmwareId)}>
							<use xlinkHref={`${breadcrumbs}#close`} />
						</svg>
					</div>
				);
			})}
		</div>
	);
};

export default Firmware;
